import React from 'react';
import {Helmet} from "react-helmet";
import PrivacyPolicyContent from "./PrivacyPolicyContent";

/** Publiczna strona z polityką prywatności. Dostępna bez logowania. */
const PrivacyPolicy = () => <>
  <Helmet>
    <title>Polityka prywatności</title>
  </Helmet>
  <div className="legal-page legal-document">
    <PrivacyPolicyContent/>
  </div>
</>;

PrivacyPolicy.url = '/privacy-policy';

export default PrivacyPolicy;
